import React from "react";
import PropTypes from "prop-types";

// The one spinner. Lifted out of LoadingNotification so a button can show the
// same arc the saving toast shows, instead of a second, slightly different one.
//
// It carries its own keyframes. The animation used to live in a <style> inside
// LoadingNotification, so it only existed while that toast was mounted - a
// spinner rendered anywhere else referenced a keyframe that was not in the DOM
// and sat still. Every instance renders the same <style>; duplicate identical
// @keyframes rules are harmless.
//
// `color` defaults to the toast's green. Pass "currentColor" to take the text
// colour of whatever the spinner sits in - that is how the grey arc on the
// disabled Bulk Pricing button is produced without a second colour constant.
const Spinner = ({ size, color, strokeWidth }) => (
  <>
    <style>{`
      @keyframes mm-spinner-spin {
        from { transform: rotate(0deg); }
        to   { transform: rotate(360deg); }
      }
    `}</style>
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
      style={{ animation: "mm-spinner-spin 1s linear infinite", flexShrink: 0 }}
    >
      <circle cx="10" cy="10" r="8" stroke={color} strokeOpacity="0.2" strokeWidth={strokeWidth} />
      <path d="M10 2A8 8 0 0 1 18 10" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
    </svg>
  </>
);

Spinner.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
};

Spinner.defaultProps = {
  size: 20,
  color: "#0A3622",
  strokeWidth: 2.5,
};

export default Spinner;
